<template>
        <v-container>

        
          <h1 >TechSpec Tools</h1>

    <li class="mt-3 subheading"><a href='#boot'>Create a bootable USB drive</a></li>
    <li class="mt-3 subheading"><a href='#discovery'>TechSpec Discovery Tool</a></li>
    
 <v-card id='boot'>
        <v-card-title
          class=" mt-5 subheading grey lighten-2"
          primary-title
        >
          Create a bootable USB drive
           <v-spacer></v-spacer>
          <v-btn class='primary'>Download iso</v-btn>
        </v-card-title>

        <v-card-text>
          you will need 2 things in order to create a bootable USB drive for TechSpec
        
          <li class="mt-3 subheading">TechSpec image file (*.iso)</li>
          <li class="mt-3 subheading">a software to format your USB drive and load the iso (we recommend using <a href='https://github.com/pbatard/rufus/releases/download/v3.5/rufus-3.5p.exe'>Rufus</a>)</li>
          <img width='40%' class='mt-2' src='https://firebasestorage.googleapis.com/v0/b/tech-reuse.appspot.com/o/rufustechspec.JPG?alt=media&token=a8bfe67b-2ad1-4b02-b116-caee5677c2df' />
          <p>for detail instruction on how to use Refus, refer to their <a href='https://rufus.ie/' target='blank'>documentation</a></p>  
        </v-card-text>

        <v-divider></v-divider>
      </v-card>
 <v-card id='discovery'>
        <v-card-title
          class=" mt-5 subheading grey lighten-2"
          primary-title
        >
          TechSpec Discovery Tool
          <v-spacer></v-spacer>
          <v-btn class='primary'  @click="downloadEXE" >Download</v-btn>
        </v-card-title>

        <v-card-text>
          Requirement to run TechSpec Discovery Tool : 
        
          <li class="mt-3 subheading">.net Framework 4.5+ *windows 10 should comes with .net Framework 4.5+ already,for other environment <a href='https://dotnet.microsoft.com/download/dotnet-framework'>download here</a></li>
          <li class="mt-3 subheading">OS : Windows 7+ </li>
        </v-card-text>

        <v-divider></v-divider>
      </v-card>
            </v-container>
</template>

<script>
const fb = require('../firebaseConfig.js')
export default {
      methods : {
      downloadEXE(){
        
      var gsReference = fb.storage.refFromURL("gs://tech-reuse.appspot.com/TechSpecDesktop_portable.zip")
      gsReference.getDownloadURL().then((url)=> { window.open(url, '_blank');
 }) 
             
      },
      }
}
</script>
